import type { IProviaOrderSummaryData } from "common/records/ProviaOrderSummaryRecord";
import type { IProViaOrder2Data } from "common/records/ProViaOrder2Record";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

export const SET_PROVIA_LOADING = "@provia/SET_LOADING";
export const RECEIVE_PROVIA_ORDERS = "@provia/RECEIVE_ORDERS";
export const RECEIVE_PROVIA_ORDER = "@provia/RECEIVE_ORDER";
export const RESET_PROVIA_STATE = "@provia/RESET_STATE";
export const OPEN_PROVIA_MODAL = "@provia/OPEN_MODAL";

export const ProviaActions = {
  setLoading: (loading: boolean) => createAction(SET_PROVIA_LOADING, loading),
  receiveOrders: (orders: IProviaOrderSummaryData[]) => createAction(RECEIVE_PROVIA_ORDERS, orders),
  receiveOrder: (order: IProViaOrder2Data) => createAction(RECEIVE_PROVIA_ORDER, order),
  resetProviaState: () => createAction(RESET_PROVIA_STATE),
  openModal: (payload: { mode: "portal" | "non_portal"; estimateGroupId: number }) =>
    createAction(OPEN_PROVIA_MODAL, payload),
};

export type ProviaActions = ActionsUnion<typeof ProviaActions>;
